import { useEffect, useState } from "react";
import { IMetadata, isDecodableContent } from "@/view/utils/decodableContent";
import { UserProperties } from "@/types/models/UserProperties.interface";
import { Assignment } from "@/types/models";

export interface IAssignment extends Assignment {
  date_created: string;
}
const useVocabularySupport = (
  hasFeature: boolean | undefined,
  userProperties: UserProperties,
  currentAssignment: IAssignment,
  contentMetadata: IMetadata[],
) => {
  const [isVocabularySupportEnabled, setIsVocabularySupportEnabled] =
    useState(false);

  const shouldVocabularySupportBeEnabled = () => {
    const { isStudent } = userProperties;
    const { assignment_config: assignmentConfig } = currentAssignment || {};
    const vocabularySupportIsDisabledForAssignment =
      assignmentConfig?.disable_vocabulary_support;

    const vocabularySupportIsDisabledForContent =
      isDecodableContent(contentMetadata);

    if (
      !isStudent &&
      (!hasFeature ||
        vocabularySupportIsDisabledForAssignment ||
        vocabularySupportIsDisabledForContent)
    ) {
      return false;
    }

    if (isStudent) {
      if (
        !currentAssignment ||
        !assignmentConfig ||
        vocabularySupportIsDisabledForAssignment ||
        vocabularySupportIsDisabledForContent
      ) {
        return false;
      }

      if (
        currentAssignment &&
        !vocabularySupportIsDisabledForAssignment &&
        !vocabularySupportIsDisabledForContent
      ) {
        // This is a temporary solution for https://newsela.atlassian.net/browse/LESS-2685
        // Ignore enabled vocab support setting if an assignment was created before the cut-off date.
        const assignmentDateCreated = new Date(currentAssignment?.date_created);
        const cutoffDate = new Date("2024-01-31T23:00:00Z");
        return assignmentDateCreated > cutoffDate;
      }
    }

    return true;
  };

  useEffect(() => {
    setIsVocabularySupportEnabled(shouldVocabularySupportBeEnabled());
  }, [
    hasFeature,
    JSON.stringify(currentAssignment),
    JSON.stringify(userProperties),
  ]);

  const toggleVocabularySupport = (isEnabled: boolean) => {
    setIsVocabularySupportEnabled(!!isEnabled);
  };

  return { isVocabularySupportEnabled, toggleVocabularySupport };
};

export default useVocabularySupport;
